import { FACT_FIND_ANSWER_MAP } from "@/constants/factfind.constants";
import { apiAnswerToFactFindValue } from "./answers";

export const populateFactFindFromApi = (answers, form) => {
  if (!answers || !answers.length) return;

  // Load FactFind answers from API Response if there are any
  const factFindKeys = Object.keys(FACT_FIND_ANSWER_MAP);
  factFindKeys.forEach((key) => {
    const interfaceKey = FACT_FIND_ANSWER_MAP[key];
    const matchingAnswer = answers.find(
      (ans) => ans.InterfaceKey === interfaceKey
    );
    if (matchingAnswer) {
      form[key] = apiAnswerToFactFindValue(matchingAnswer);
    }
  });
};

export const hasAnyFactFindAnswers = (answers) => {
  if (!answers) return false;
  const factFindInterfaceKeys = Object.values(FACT_FIND_ANSWER_MAP);
  return answers.some((ans) =>
    factFindInterfaceKeys.includes(ans.InterfaceKey)
  );
};
